// enums
export var AuthorType;
(function (AuthorType) {
    AuthorType["Column"] = "column";
    AuthorType["Line"] = "line";
})(AuthorType || (AuthorType = {}));
export var PriceDetailsType;
(function (PriceDetailsType) {
    PriceDetailsType["MARKED_LIST"] = "marked-list";
    PriceDetailsType["SETTINGS"] = "settings";
})(PriceDetailsType || (PriceDetailsType = {}));
export var PriceLabelColor;
(function (PriceLabelColor) {
    PriceLabelColor["BLUE"] = "blue";
    PriceLabelColor["GREEN"] = "green";
    PriceLabelColor["YELLOW"] = "yellow";
    PriceLabelColor["PURPLE"] = "purple";
    PriceLabelColor["RED"] = "red";
})(PriceLabelColor || (PriceLabelColor = {}));
export var PreviewItemType;
(function (PreviewItemType) {
    PreviewItemType["Video"] = "video";
    PreviewItemType["Image"] = "image";
})(PreviewItemType || (PreviewItemType = {}));
export var PlayButtonType;
(function (PlayButtonType) {
    PlayButtonType["Default"] = "default";
    PlayButtonType["Text"] = "text";
})(PlayButtonType || (PlayButtonType = {}));
export var PlayButtonThemes;
(function (PlayButtonThemes) {
    PlayButtonThemes["Blue"] = "blue";
    PlayButtonThemes["Grey"] = "grey";
})(PlayButtonThemes || (PlayButtonThemes = {}));
export var MediaVideoType;
(function (MediaVideoType) {
    MediaVideoType["Default"] = "default";
    MediaVideoType["Player"] = "player";
})(MediaVideoType || (MediaVideoType = {}));
export var MediaVideoControlsType;
(function (MediaVideoControlsType) {
    MediaVideoControlsType["Default"] = "default";
    MediaVideoControlsType["Custom"] = "custom";
})(MediaVideoControlsType || (MediaVideoControlsType = {}));
